<template>
  <div class="dashboard">
    <section class="page">
      <header class="pageHeader">
        <div class="page__Inner">
          <h1 class="page__Title">{{ $store.getters.getStringTranslation('welcomeMotyro') }}!</h1>
          <p>{{ $store.getters.getStringTranslation('welcomeMotyroDesc') }}</p>
        </div>
      </header>
      <div class="page__Inner">
        <h2>{{ $store.getters.getStringTranslation('nextSteps') }}</h2>
        <p class="message" v-if="isAdmin && checkOrg">
          {{ $store.getters.getStringTranslation('beforeBegin') }}

          <router-link :to="{ name: 'Organisation' }"
            >{{ $store.getters.getStringTranslation('organisationInfo') }}
          </router-link>
          {{ $store.getters.getStringTranslation('visitingLeftHand') }}
        </p>

        <a
          target="_blank"
          class="button--endorse"
          href="https://peopleoverprof.it/resources/campaigns?search=%7B%22api_keys%22%3A%5B%22bee095f2-1525-477f-bc90-640a3e41a8de%22%5D,%22tags%22%3A%7B%22actor%22%3A%5B%5D,%22ally%22%3A%5B%5D,%22country%22%3A%5B%5D,%22sector%22%3A%5B%5D,%22topic%22%3A%5B%5D%7D,%22types%22%3A%5B%5D,%22search_query%22%3A%22%22,%22offset%22%3A0,%22limit%22%3A12,%22order_by%22%3A%22start_datetime%22,%22order_dir%22%3A%22desc%22,%22lang%22%3Anull,%22start_datetime%22%3Anull,%22end_datetime%22%3Anull%7D"
          >{{ $store.getters.getStringTranslation('endoreseCampaigns') }}</a
        >

        <div class="page__Columns">
          <div v-if="isAdmin">
            <ul>
              <li>
                <router-link :to="{ path: '/settings/account' }">{{
                  $store.getters.getStringTranslation('editAccount')
                }}</router-link>
              </li>
              <li>
                <router-link :to="{ path: '/settings/organisation' }">{{
                  $store.getters.getStringTranslation('updateOrgInfo')
                }}</router-link>
              </li>
              <!-- <li>
                <router-link :to="{ path: '/settings/invite' }">Invite more users to your organisation</router-link>
              </li> -->
              <li>
                <router-link :to="{ path: '/users/active' }">{{
                  $store.getters.getStringTranslation('editExistingUsers')
                }}</router-link>
              </li>
            </ul>
          </div>
          <div>
            <ul>
              <template v-for="item in nav">
                <li :key="item.url" v-if="enabled === true || enabled[item.id]">
                  <router-link :to="{ path: item.url }"
                    >{{ $store.getters.getStringTranslation(item.label) }}
                  </router-link>
                </li>
              </template>
            </ul>
          </div>
          <div>
            <ul>
              <li v-if="isSuperAdmin">
                <router-link :to="{ path: '/submissions' }">{{
                  $store.getters.getStringTranslation('reviewSubmissions')
                }}</router-link>
              </li>
              <li v-if="isSuperAdmin">
                <router-link :to="{ path: '/tags' }">{{ $store.getters.getStringTranslation('editTags') }}</router-link>
              </li>
              <li>
                <router-link :to="{ path: '/campaigns' }">{{
                  $store.getters.getStringTranslation('editCampaigns')
                }}</router-link>
              </li>
              <li>
                <router-link :to="{ path: '/events' }">{{
                  $store.getters.getStringTranslation('editEvents')
                }}</router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <section class="page">
      <div class="page__Inner">
        <h2>Activity</h2>
        <p>Check current activity on the Motyro platform.</p>
        <div class="activityButtonWrapper">
          <router-link :to="{ path: '/activity' }" class="button">View all activity</router-link>
        </div>
      </div>
    </section>
    <!-- <section class="page" v-else>
      <div class="page__Pending">
        <icon name="users" />
        <h2>Your account is pending approval</h2>
        <p>Hey, thanks for getting on board! Seems your account is still pending approval and we highly recommend you contact one of your organisational representatives to speed things up and get approved soon.</p>
      </div>
    </section>-->
  </div>
</template>

<script>
export default {
  name: 'Dashboard',
  data() {
    return {
      nav: [
        { id: 'blog', url: '/blog', label: 'editBlogPosts' },
        { id: 'page', url: '/pages', label: 'editPages' },
        { id: 'article', url: '/news', label: 'editExternalArticles' },
        {
          id: 'case_studies',
          url: '/case-studies',
          label: 'editCaseStudies',
        },
      ],
    }
  },
  computed: {
    user() {
      return this.$store.state.accounts.user
    },
    org() {
      return this.$store.state.accounts.org
    },
    checkOrg() {
      // Check if l10n exists at all
      if (this.org.l10n && this.org.l10n.length === 0) return true
      // Check if both description and foreword exist and if they are empty
      if (this.org.l10n && this.org.l10n[0] && (!this.org.l10n[0].foreword || !this.org.l10n[0].description))
        return true
      return false
    },
    isAdmin() {
      if (this.user.is_admin || this.user.is_org_admin) return true
      return false
    },
    isSuperAdmin() {
      if (this.user.is_admin) return true
      return false
    },
    enabled() {
      if (this.$store.state.accounts.org.websites && this.$store.state.websites.current[0]) {
        const currentApi = this.$store.state.websites.current[0]

        const current = this.$store.state.accounts.org.websites.find((website) => website.api_key === currentApi)
        if (current && current.additionals.defaults) return current.additionals.defaults.resources
      }

      return true
    },
  },
}
</script>
